/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const car_2 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12.18 7.603c.745 0 1.46.353 1.988.984.528.632.828 1.49.832 2.385 0 .298-.098.584-.273.794a.861.861 0 0 1-.66.33h-.976m-.91-4.493S10.78 2.55 7.046 2.55c-.106 0-.213.003-.32.009m5.453 5.044L6.727 7.6M2.73 12.095a1.273 1.273 0 0 0 2.535.16m-2.535-.16a1.273 1.273 0 1 1 2.535.16m-2.535-.16h-.816a.785.785 0 0 1-.36-.088.933.933 0 0 1-.3-.252 1.152 1.152 0 0 1-.195-.373A1.305 1.305 0 0 1 1 10.947c.048-1.287.208-2.396.457-3.347m11.633 4.495a1.273 1.273 0 0 1-2.536.16m2.536-.16a1.273 1.273 0 1 0-2.536.16M6.727 2.558v5.04m0-5.04c-2.138.118-4.331 1.45-5.27 5.04m5.27 0h-5.27m3.808 4.655h5.29"
    />
  </svg>
)
export default car_2
